module.exports = __webpack_public_path__ + "media/images/front/toplogo-4f26395a5657a094ca71b0eacd9cfe58.png";